import { SET_USERNOTIFICATION } from '../actions';

const notification = (state = [], action) => {
  switch (action.type) {
	case SET_USERNOTIFICATION:
      return [...action.value];  
    default: return state;
  }
}

export default notification;
